import { NgForm } from '@angular/forms';

export class FormHelperService {
    validate(form: NgForm): NgForm {
        Object.keys(form.form.controls).forEach((key) => {
            const control = form.form.controls[key];
            if (!control.touched) {
                control.markAsTouched({ onlySelf: true });
                control.updateValueAndValidity({ onlySelf: true });
            }
        });

        return form;
    }
}
